'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _players = require('../../store/actions/players');

var iconName = 'slowforward';
var dataHudlElement = 'vi-controls-slowmotionforward';
var SLOW_SPEED = 0.5;
var NORMAL_SPEED = 1;
var title = 'vi.player.controls.slow_forward';

var mapStateToProps = function mapStateToProps() {
  return {
    title: title,
    iconName: iconName,
    dataHudlElement: dataHudlElement
  };
};

function handleMouseDown(playerId, speed, self) {
  return function (dispatch, getState) {
    var paused = getState().players[playerId].paused;
    if (paused) dispatch((0, _players.play)(playerId, true));
    dispatch((0, _players.setPlaybackRate)(playerId, speed));
    self.setState({ paused: paused });
  };
}

function onMouseDown(dispatch, ownProps, playerId, self) {
  dispatch(handleMouseDown.call(this, playerId, SLOW_SPEED, self));
}

function onMouseUp(dispatch, ownProps, playerId, self) {
  dispatch(self.state.paused ? (0, _players.pause)(playerId, true) : (0, _players.play)(playerId, true));
  dispatch((0, _players.setPlaybackRate)(playerId, NORMAL_SPEED));
}

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref) {
  var playerId = _ref.playerId;

  return {
    onMouseDown: onMouseDown.bind(null, dispatch, ownProps, playerId),
    onMouseUp: onMouseUp.bind(null, dispatch, ownProps, playerId)
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];